/** Standard ERC-20 `totalSupply()` — used by every reader. */
export const TotalSupplyAbi = [
  {
    name: 'totalSupply',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const

/** ERC-4626 read surface — `totalAssets()` + `convertToAssets(uint256)`. */
export const Erc4626ReadAbi = [
  {
    name: 'totalAssets',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'convertToAssets',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'uint256', name: 'shares' }],
    outputs: [{ type: 'uint256', name: 'assets' }],
  },
] as const

/** ERC-4626 read surface using `previewRedeem` for the rate instead of
 *  `convertToAssets`. Some multi-asset vaults (YieldNest ynLSDe) revert
 *  on `convertToAssets` but implement `previewRedeem`. */
export const Erc4626PreviewRedeemAbi = [
  {
    name: 'totalAssets',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'previewRedeem',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'uint256', name: 'shares' }],
    outputs: [{ type: 'uint256', name: 'assets' }],
  },
] as const
